export const removeTrailingSlash = (path: string) => path.replace(/\/$/, '');

export const removeDuplicatedSlashes = (path: string) =>
  path.replace(/\/\//g, '/');
